import { render, staticRenderFns } from "./GuppyChatSendMediaMessage.vue?vue&type=template&id=5cded7a8&"
import script from "./GuppyChatSendMediaMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyChatSendMediaMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports